import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { URL_MAP } from '../../shared/urlMap';
import { environment as ENV } from '../../../environments/environment';

/** Catálogo expuesto por ova-back-traslados (GET /parentescos). */
export interface ParentescoTrasladoDTO {
  codigo: string;
  nombre?: string;
  descripcion?: string;
}

@Injectable({
  providedIn: 'root',
})
export class ParentescosTrasladosService {
  private apiUrl = `${ENV.HOST}${URL_MAP.API.PARENTESCOS_TRASLADOS}`;

  constructor(private http: HttpClient) {}

  getParentescos(): Observable<ParentescoTrasladoDTO[]> {
    return this.http.get<ParentescoTrasladoDTO[]>(this.apiUrl);
  }
}
